import { ICustomInspectionTypeSettings } from '../ICustomInspectionTypeSettings';
import { crowBeeldkwaliteitScoreToColorCode } from './crowBeeldkwaliteitScoreToColorCode';

const translation = {
    en: {
        crowBeeldkwaliteit: {
            crowBeeldkwaliteit: 'CROW image quality',
            crowBeeldkwaliteitResult: 'Inspection',
            visualsAndDocuments: 'Visuals and documents',
        },
        inspectionStandard: {
            crowBeeldkwaliteit: 'CROW image quality',
        },
    },
    nl: {
        crowBeeldkwaliteit: {
            crowBeeldkwaliteit: 'CROW beeldkwaliteit',
            crowBeeldkwaliteitResult: 'Beoordeling',
            visualsAndDocuments: 'Afbeeldingen en documenten',
        },
        inspectionStandard: {
            crowBeeldkwaliteit: 'CROW beeldkwaliteit',
        },
    },
};

export function conditionScoreToScore(conditionScore?: number | null | string) {
    if (conditionScore === undefined || conditionScore === null) {
        return null;
    }
    switch (conditionScore.toString()) {
        case '0':
            return 'A+';
        case '1':
            return 'A';
        case '2':
            return 'B';
        case '3':
            return 'C';
        case '4':
            return 'D';
        case '5':
            return 'NVT';
        default:
            return null;
    }
}

export function conditionScoreToColorCode(conditionScore?: number | null | string) {
    const score = conditionScoreToScore(conditionScore);
    return crowBeeldkwaliteitScoreToColorCode(score);
}

export const crowBeeldkwaliteitSettings: ICustomInspectionTypeSettings = {
    inspectionStandardType: 'crowBeeldkwaliteit',
    translation,
    conditionScoreToScore,
    conditionScoreToColorCode,
};
